export default __webpack_public_path__ + "static/gs-R-code--mobile-ad257cbbe06a0ac5ab4a09bca05f8d28.webp";